module.exports = __webpack_public_path__ + "media/dashboard/assets/images/credit-card/american-express-cbdc60984deedd1c41b4cee2c9ee30fa.svg";